import styled from '@emotion/styled';
import Avatar from '@mui/material/Avatar';

interface StyleProps {
  size: number;
}

export const CardAvatar = styled(Avatar)`
  width: ${(props: StyleProps) => props.size + 'px'};
  height: ${(props: StyleProps) => props.size + 'px'};
`;
